import { render, staticRenderFns } from "./AiAnalisysIcon.vue?vue&type=template&id=1664be7e"
import script from "./AiAnalisysIcon.vue?vue&type=script&lang=js"
export * from "./AiAnalisysIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports